import { fromJS, Record } from 'immutable';
import { isEqual } from 'lodash';
import { FileItem } from 'ng2-file-upload';
import {
  generateKeys,
  generateSchema,
  setInModel,
} from '../../utils/helpers/model.helper';
import { File } from '../files/file.model';
import { Attachment } from './attachment.model';

export const ATTACHMENT_VIEW_SCHEMA = Object.freeze({
  ATTACHMENT: Attachment,
  FILE_ITEM: null,
  PROGRESS: 0,
  ERROR: '',
  EMIT_EVENT: true,
});
const RECORD = generateSchema(ATTACHMENT_VIEW_SCHEMA);
const KEYS: any = generateKeys(ATTACHMENT_VIEW_SCHEMA);

export class AttachmentView extends Record(RECORD) {
  static KEYS: any = KEYS;

  static fromFileItem(fileItem: FileItem, file: File): AttachmentView {
    const props = {
      [KEYS.ATTACHMENT]: new Attachment({
        [Attachment.KEYS.TITLE]: fileItem.file.name,
        [Attachment.KEYS.FILE]: file,
      }),
      [KEYS.FILE_ITEM]: fileItem,
    };

    return new AttachmentView(props);
  }

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));

    const selfModel = setInModel(this, [
      {
        key: KEYS.ATTACHMENT,
        value: new Attachment(this.attachment),
      },
    ]);

    return selfModel as AttachmentView;
  }

  get attachment(): Attachment {
    return this.get(KEYS.ATTACHMENT);
  }

  setAttachment(attachment): AttachmentView {
    return this.set(KEYS.ATTACHMENT, attachment) as AttachmentView;
  }

  get id() {
    return this.attachment.id;
  }

  get title() {
    return this.attachment.title;
  }

  get description() {
    return this.attachment.description;
  }

  get file(): File {
    return this.attachment.file;
  }

  get fileUrl(): string {
    return this.attachment.fileUrl;
  }

  setFile(file: File): AttachmentView {
    const attachment = this.attachment.setFile(file);
    return this.set(KEYS.ATTACHMENT, attachment) as AttachmentView;
  }

  get fileItem(): FileItem {
    return this.get(KEYS.FILE_ITEM);
  }

  get progress(): number {
    return this.get(KEYS.PROGRESS);
  }

  setProgress(value: number): AttachmentView {
    return this.set(KEYS.PROGRESS, value) as AttachmentView;
  }

  get error(): string {
    return this.get(KEYS.ERROR);
  }

  setError(msg: string): AttachmentView {
    return this.set(KEYS.ERROR, msg) as AttachmentView;
  }

  get emitEvent(): boolean {
    return this.get(KEYS.EMIT_EVENT);
  }

  hasFileItem(fileItem): boolean {
    return this.fileItem && isEqual(this.fileItem, fileItem);
  }
}
